import { useAuth } from "../../../context/AuthContext";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../pages/Freight/Common/dashboard.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "../../../components/Button";
import InputField from "../../../components/InputField";
import api from "../../../api/api";
import TotalCusImg from "../../../image/TotalCus.svg";
import FollowedImg from "../../../image/Followed.svg";
import ConvertImg from "../../../image/Convert.svg";
import RevenueImg from "../../../image/Revenue.svg";
import ObtainedImg from "../../../image/Obtained.svg";
import importImg from "../../../image/Import.svg";
import exportImg from "../../../image/Export.svg";
import SpecialImg from "../../../image/star.svg";
import Breadcrumbs from "../../../components/Breadcrumbs";
import HighImg from "../../../image/highvolume.svg";
 
const SALES_DASHBOARD_FILTER_KEY = "salesDashboardFilters";
 
const SalesDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
 
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [open, setOpen] = useState(false);
  const [kpiData, setKpiData] = useState({});
  const [createdByList, setCreatedByList] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
 
  const inputRef = useRef(null);
 
  const { logout } = useAuth();
 
  const handleLogout = () => {
    // Remove dashboard filters
    localStorage.removeItem("salesDashboardFilters");
 
    logout();
  };
  <button
    onClick={() => {
      localStorage.removeItem("salesDashboardFilters");
      logout();
    }}
  >
    Logout
  </button>;
 
  // Sales CARDS
  const salesBoxData = [
    {
      id: 1,
      heading: "Total New Customers",
      image: TotalCusImg,
      key: "total_clients",
    },
    {
      id: 2,
      heading: "Total Follow Ups",
      image: FollowedImg,
      key: "followed_up",
    },
    {
      id: 3,
      heading: "Total Confirmed Bookings",
      image: ConvertImg,
      key: "converted_customers",
    },
    {
      id: 4,
      heading: "Special Enquiries",
      image: SpecialImg,
      key: "special_enquiries",
    },
    {
      id: 5,
      heading: "High Volume Customers",
      image: HighImg,
      key: "high_volume_customers",
    },
    {
      id: 6,
      heading: "Total Addressable Revenue",
      image: RevenueImg,
      key: "total_addressable_revenue",
    },
    {
      id: 7,
      heading: "Serviable Addreable Revenue",
      image: RevenueImg,
      key: "serviable_addreable",
    },
    {
      id: 8,
      heading: "Actual Revenue Obtained",
      image: ObtainedImg,
      key: "actual_revenue",
    },
    { id: 9, heading: "FCL Import", image: importImg, key: "fcl_import" },
    { id: 10, heading: "FCL Export", image: exportImg, key: "fcl_export" },
    { id: 11, heading: "LCL Import", image: importImg, key: "lcl_import" },
    { id: 12, heading: "LCL Export", image: exportImg, key: "lcl_export" },
  ];
 
  // Fetch KPI data
  const fetchKpis = async (start, end, createdBy = "") => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        window.location.href = "/login";
        return;
      }
 
      const params = {};
      if (start && end) {
        params.fromDate = start.toISOString();
        params.toDate = end.toISOString();
      }
      if (createdBy) {
        params.CreateBY = createdBy;
      }
 
      const { data } = await api.get("/sales-dashboard/kpis", {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
 
      setKpiData(data);
    } catch (err) {
      console.error("Failed to fetch KPI data:", err);
    }
  };
 
  // Fetch "Created By" dropdown
  const fetchCreatedByList = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;
 
      const { data } = await api.get("/sales-dashboard/sales-team-names", {
        headers: { Authorization: `Bearer ${token}` },
      });
 
      setCreatedByList(data.salesReps || []);
    } catch (err) {
      console.error("Failed to fetch user list:", err);
    }
  };
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("salesDashboardReload", "true");
    };
 
    window.addEventListener("beforeunload", handleBeforeUnload);
 
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
 
  // 🔥 MAIN EFFECT: handle reload vs back navigation
 
  useEffect(() => {
    if (!user) return;
 
    fetchCreatedByList();
 
    const isReload = sessionStorage.getItem("salesDashboardReload");
 
    if (isReload) {
      //  Full browser reload → clear filters
      sessionStorage.removeItem("salesDashboardReload");
      localStorage.removeItem(SALES_DASHBOARD_FILTER_KEY);
      setDateRange([null, null]);
      setSelectedUser("");
      fetchKpis();
      return;
    }
 
    //  Breadcrumb / back navigation → restore filters
    const storedFilters = localStorage.getItem(SALES_DASHBOARD_FILTER_KEY);
    if (storedFilters) {
      const { startDate, endDate, selectedUser } = JSON.parse(storedFilters);
 
      setDateRange([
        startDate ? new Date(startDate) : null,
        endDate ? new Date(endDate) : null,
      ]);
      setSelectedUser(selectedUser || "");
 
      fetchKpis(
        startDate ? new Date(startDate) : null,
        endDate ? new Date(endDate) : null,
        selectedUser,
      );
    } else {
      fetchKpis();
    }
  }, [user]);
 
  const handleFilter = () => {
    const filters = {
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
      selectedUser: selectedUser || "",
    };
 
    localStorage.setItem(SALES_DASHBOARD_FILTER_KEY, JSON.stringify(filters));
    fetchKpis(startDate, endDate, selectedUser);
    setOpen(false);
  };
 
  const handleClearFilter = () => {
    setDateRange([null, null]);
    setSelectedUser("");
    setOpen(false);
    localStorage.removeItem(SALES_DASHBOARD_FILTER_KEY);
    fetchKpis();
  };
 
  const handleToggle = () => setOpen((prev) => !prev);
 
  if (!user) return <div>Loading...</div>;
 
  const activeBoxData = user?.user_role === "SuperAdmin" ? salesBoxData : [];
 
  return (
    <>
      <Breadcrumbs />
 
      {(user?.user_role === "Admin" || user?.user_role === "SuperAdmin") && (
        <div className="row align-items-center mb-4 flex-wrap">
          <div className="col-sm-6 col-md-3">
            <input
              ref={inputRef}
              readOnly
              value={
                startDate && endDate
                  ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                  : ""
              }
              onClick={() => setOpen(!open)}
              placeholder="Select Date Range"
              className="form-control"
            />
            {open && (
              <div className="position-absolute bg-white shadow p-3 rounded mt-1 z-3">
                <DatePicker
                  inline
                  selectsRange
                  monthsShown={2}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  maxDate={new Date()}
                />
                <div className="d-flex justify-content-end mt-2">
                  <Button onClick={handleToggle} text="Done" btncls="me-2" />
                  <Button
                    onClick={handleClearFilter}
                    text="Clear"
                    variant="danger"
                  />
                </div>
              </div>
            )}
          </div>
 
          <div className="col-md-4 col-lg-3 mt-3 mt-md-0">
            <select
              className="form-select custom-select"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value="">Select Created By</option>
              {createdByList.map((usr) => (
                <option key={usr.user_id} value={usr.full_name}>
                  {usr.full_name}
                </option>
              ))}
            </select>
          </div>
 
          <div className="col-sm-6 col-md-4 col-lg-4 d-flex mt-3 mt-sm-0 align-items-center gap-2">
            <Button
              onClick={handleFilter}
              text="Apply Filter"
              btncls="me-2 mt-0 w-100 w-sm-auto"
            />
            <Button
              onClick={handleClearFilter}
              text="Clear Filter"
              variant="danger"
              btncls="mt-0 w-100 w-sm-auto light-red"
            />
          </div>
        </div>
      )}
 
      <div className="row">
        {activeBoxData.map((box) => (
          <div className="col-sm-6 col-lg-4 col-xl-3 mb-4 d-flex" key={box.id}>
            <div
              className="mainbox w-100 text-center"
              style={box.id <= 5 ? { cursor: "pointer" } : {}}
              onClick={() => {
                const state = {
                  kpiKey: box.key,
                  fromDate: startDate?.toISOString() || null,
                  toDate: endDate?.toISOString() || null,
                  createdBy: selectedUser || null,
                };
                if (box.id === 1) navigate("/sales-clients", { state });
                else if (box.id === 2) navigate("/total-followups", { state });
                else if (box.id === 3) navigate("/sales-bookings", { state });
                else if (box.id === 4)
                  navigate("/special-enquiries", { state });
                else if (box.id === 5)
                  navigate("/high-volume-customers", { state });
              }}
            >
              <div className="icon mb-2">
                <img
                  src={box.image}
                  alt={box.heading}
                  style={{ width: 40, height: 40 }}
                />
              </div>
              <div>
                <h2 className="mb-2">{box.heading}</h2>
                <h3>{kpiData[box.key] ?? 0}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
 
export default SalesDashboard;